import { v4 as uuidv4 } from 'uuid';

function getHeaders(correlationId) {
  return {
    'Request-Id': correlationId,
    'correlation-id': correlationId,
    'one-data-correlation-id': correlationId,
    'Content-Type': 'application/json',
  };
}

// eslint-disable-next-line max-params -- correlationId is an optional 4th arg; matches sibling callApi.js
export async function callFxgApi(apiUrl, methodType, requestData, correlationId) {
    // Use a single id across the headers and the body requestId for this request.
    // Callers can pass correlationId to correlate multiple calls in one user
    // action; otherwise a fresh id is minted per call.
    const requestCorrelationId = correlationId ?? uuidv4();
    let response = null;
    let hasErrors = true;
    let status = null;
    let apiResponse = {};

    if (apiUrl) {
      try {
        const requestCommonData = {
          requestId: requestCorrelationId,
        };
        if (methodType === 'POST' || methodType === 'PUT') {
          apiResponse = await fetch(apiUrl, {
            method: methodType,
            headers: getHeaders(requestCorrelationId),
            credentials: 'include',
            body: JSON.stringify({ ...requestCommonData, ...requestData }),
          });
        } else if (methodType === 'GET' || methodType === 'DELETE') {
          apiResponse = await fetch(apiUrl, {
            method: methodType,
            headers: getHeaders(requestCorrelationId),
            credentials: 'include',
          });
        }
        // On either path an unparseable body resolves to `null` so callers have a
        // single "no usable body" sentinel to check regardless of success/error.
        if (!apiResponse.ok) {
          // Surface every non-ok status consistently instead of throwing for
          // unlisted codes, so callers always receive the parsed body + status.
          response = await apiResponse.json().catch((err) => {
            console.error('Error parsing error response', err);
            return null;
          });
          hasErrors = true;
          status = apiResponse.status;
        } else {
          response = await apiResponse.json().catch((err) => {
            console.error('Error parsing success response', err);
            return null;
          });
          hasErrors = false;
          status = apiResponse.status;
        }
      } catch (exe) {
        console.error(exe);
        hasErrors = true;
        // apiResponse may still be {} (e.g. network failure before fetch resolves),
        // so guard against an undefined status and fall back to null.
        status = apiResponse?.status ?? null;
      }
    }
    return {
      response,
      hasErrors,
      status,
    };
  }
